import { render, staticRenderFns } from "./QueriesWidget.vue?vue&type=template&id=323e7434&"
import script from "./QueriesWidget.vue?vue&type=script&lang=js&"
export * from "./QueriesWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports